module.exports = __webpack_public_path__ + "assets/img/WTILogoHR.ba3d8955.png";